import { dbFieldTypeMap } from '@databases/collab/convert/to-collab';
import { type DatabaseFieldType } from '@databases/types/database';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types.ts';

export function assertEntryValueTypesSupported(
  values: Record<string, { type: DatabaseFieldType }>
): Result<void, SdkError> {
  for (const [fieldId, value] of Object.entries(values)) {
    if (!dbFieldTypeMap[value.type]) {
      return err({
        type: 'VALIDATION_ERROR',
        issues: [
          {
            code: 'custom',
            path: ['entry', 'values', fieldId, 'type'],
            message: `Unsupported field type '${value.type}'`
          }
        ]
      });
    }
  }

  return ok(undefined);
}
